import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import Radio from '@mui/material/Radio';
import "./RerouteModalStyles.css";
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { ListItemText, Typography } from "@mui/material";
import { FetchForceReroute, ForceReroute, changeDomainExpert, getExpertProfileData,getExpertOpenPageData,getKeyTag } from "../../../API/api";
import { toast } from "react-toastify";
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ListSubheader from '@mui/material/ListSubheader';
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../NewComponent/Button/Button";
import { ModalHeader as ModalHeaderStyles } from "../../../Constants";
import Button2 from "../../../NewComponent/Button2/Button2";
import MultiSelect from "../../MultiSelect/MultiSelect";






export default function RerouteModal() {
    const [isSelected, setIsSelected] = useState("a");
    const [displaySection, setDisplay] = useState(true);
    const modalState = useSelector((state) => state.domain);
    const expertState = useSelector((state) => state.expertOpenData);
    const userState = useSelector((state=>state.user));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {isDataLoadingExpertOpen,getIsOpenedQuestion, advanceFilterModalToggle, getDomainValuesInExpertOpen,getOpenDataCountExpert,getExpertOpenData,refreshExpertOpenTabData } = bindActionCreators(Actions, dispatch);
    const [selectedUser, setSelectedUser] = useState([]);
    const [isComment, setIsComment] = useState('');
    const [userList, setUsersList] = useState(expertState.userData.users);
    const [domainId, setDomainId] = useState("");
    const [val, setVal] = useState(null);
    const [selectedOption,setSelectedOption] = useState(true);
    const [domainName, setDomainName] = useState({value:expertState.getSelectedDomain,label:expertState.getSelectedDomain});
    const [routeQuestionBasedOnDomain, setRouteQuestionBasedOnDomain] = useState(
        {value:expertState.getSelectedDomain,label:expertState.getSelectedDomain
    })
    const [domainMessage, setDomainMessage] = useState();
    const [optvalue, setOptValue] = useState({label:'Select Experts',value:'Select Experts'});
    const { getForceRerouteUsersStatus,getExpertData } = bindActionCreators(Actions, dispatch);
    const currentRoute = useLocation();
    const onChangeVal = (e) => {
        getDomainValuesInExpertOpen(e)
    }


    const onChangeOption = (e) => {
        if (e.target.value === 'a') {
            setIsSelected(e.target.value)
            setDisplay(true)
        }
        else if (e.target.value === 'b') {
            setIsSelected(e.target.value)
            setDisplay(false);
        }
    }

    const onClickCancel = () => {
        advanceFilterModalToggle({ bool: false, value: "" })
    }

    const removeElement = (val) => {
        setUsersList((current) =>
        current.map((v) => {
            if (v.label === 'Choose an Expert') {
                return {
                    ...v,
                    options: v.options.filter((obj) => obj.userUuid !== val) 
                };
            }
            return v;
        })
    );
    };

    const toggleButtonToast = (message) => {
        return (
            <>
                <span style={{ fontSize: "12px",color:'#2b2f33' }}>
                    {message}
                </span>
            </>
        );
    };

    const onChangeSelectedUser = (e) => {
        let newObj = {...expertState.userData}
        setOptValue({label:e.label,value:e.value});
        setSelectedOption(false);
        setUsersList((prevUserList) =>
        prevUserList.map((obj) => {
            if (obj.label === "Choose an Expert") {
                const updatedOptions = obj.options.filter((ob) => {
                    if (ob.userUuid === e.value) {
                        setSelectedUser((prevSelected) => [...prevSelected, ob]); 
                        return false; // Exclude the matched object (removing it)
                    }
                    return true;
                });
    
                return { ...obj, options: updatedOptions };
            }
            return obj;
        })
    );
        // newObj.users = userList
        let newObj2 = {...newObj}
        // getForceRerouteUsersStatus(newObj2)
        // console.log(optvalue,'check')
    }

    const deleteItem = (val) => {
        setSelectedUser((state) => state.filter((item) => item.userUuid !== val.userUuid))
        // setUsersList((prev)=>prev.map((obj)=>{
        //     if(obj.label === 'Assigned Experts')
        //     {
        //         obj.options.filter((ob)=>{
        //             console.log(ob,'check object inside')
        //             if(ob.value !== val.userUuid)
        //             {
        //                 return ob;
        //             }
        //         })
        //     }
        //     return obj;
        // }))
        setUsersList((prev) =>
        prev.map((obj) => {
          if (obj.label === "Choose an Expert") {
            return {
                label:obj.label,
              options: [...obj.options, val], 
            };
          }
          return obj; 
        }).filter((ob,index)=>index < 2)
      );
    }

    const addUsersList = (val) => {
        console.log(val,'check val')
        // setSelectedUser((current) => current.filter((obj) => {
        //     console.log(current);
        //     if (obj.userUuid === val.userUuid) {
        //         setUsersList([...userList, val]);
        //         return val;
        //     }
        // }))
        selectedUser.filter((obj) => {
            if (obj.userUuid === val.userUuid) {
                setUsersList([...userList, val])
            }
            return obj;
        })
        deleteItem(val);
        setOptValue('');
    }

    const onClickReroute = () => {
        const payload = {
            comment: isComment,
            expertIds: selectedUser.map((usr) => { return (usr.userUuid) }),
            question: "",
            questionId: expertState.selectedQuestion
        }
        // let filteredData = expertState.openPageData.filter((obj) => {
        //   return obj.questionUuid !== expertState.selectedQuestion
        // })
        ForceReroute(payload).then((res) => {
            if (res===undefined) return;
            if (res.data.success === true || res.data.data !== '') {
                advanceFilterModalToggle({ bool: false, value: "" });
                toast.success(toggleButtonToast(res.data.message), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                // getExpertOpenData(filteredData);
                if(!currentRoute.pathname.includes('/open')){
                    navigate('/expertHome/open');
                }
                // refreshExpertOpenTabData(Math.random() * 10);
                callExpertOpenApi();
                window.scrollTo({top: 0, behavior: 'smooth'})
                // getOpenDataCountExpert(filteredData.length); 
            }
        })
    }

    const commentInput = (e) => {
        setIsComment(e.target.value);
    }

    const getDomainId = (data) => {
        const newFilter = userState.expertTopics.filter((arr) => {
            if (data === arr.name) {
                return arr;
            }
        })
        setDomainId(newFilter[0].indexId);
        return newFilter[0].indexId;
    }

    const onChangeFetchUsers = (e) => {
        getDomainId(expertState.getSelectedDomain);
        const index = userState.expertTopics.map(item => item.name).indexOf(e.value);
        FetchForceReroute(expertState.selectedQuestion, index).then((res) => {
            if (res===undefined) return;
            if (res.data.success === true || res.data.data !== '') {
                getForceRerouteUsersStatus(res.data.data);
                setDomainName(e)
                //       let newSetOfUsers = res.data.data.users.map((obj,ind)=>{
                //     let newObj = {...obj, label:obj.firstName + " " + obj.lastName,value:obj.userUuid}
                //     return newObj;
                // })
                // res.data.data.users = newSetOfUsers;
                // let newObj = {...res.data.data}
                // setUsersList(newObj.users.filter((arr) => { return arr.questionAssigned === false }));
                if(selectedUser.length > 0)
                {
                    // res.data.data.users.map((obj)=>{
                    //     let newObj = {...obj,label:obj.firstName + obj.lastName,value:obj.userUuid}
                    //     addUsersList(newObj);
                    //     return obj;
                    // })
                    setSelectedUser([]);
                }
                setOptValue('')
            }
        })
    }

    const callExpertOpenApi = () => {
        getExpertOpenPageData(expertState.pageNo,
        expertState.sortFilterVal.origValue,
        expertState.sortFilterVal.sortOrder,
        expertState.sortChange,
        expertState.domainFilter,
        expertState.ownRecords).then((res)=>{
            if(res === undefined) return;
            if(res.data.success || res.data.data !== '')
            {
                getExpertOpenData(res.data.data);
                getOpenDataCountExpert(res.data.count);
                isDataLoadingExpertOpen(false);
                getIsOpenedQuestion(true)
                let quesTds = res.data.data.map((obj) => obj.questionUuid)
                if (quesTds && quesTds.length > 0) {
                    getKeyTag(quesTds)
                }
            }
        })
    }

    const onChangeDomainSelect = (e) => {
        // setDomainName(e);
        setRouteQuestionBasedOnDomain(e)
        if (e.name!== expertState.getSelectedDomain) {
            getDomainId(e.name);
            // setDomainName(e.target.value);
            // setDomainName(e)
            setRouteQuestionBasedOnDomain(e)
            setDomainMessage('This action will result in question being routed to Expert with selected domain. Continue?')
        }
    }

    const changeDomainToast = (message) => {
        return (
            <>
                <span style={{ fontSize: "12px",color:'#2b2f33' }}>
                    {message}
                </span>
            </>
        );
    };

    const changeDomain = () => {
        getDomainId(expertState.getSelectedDomain);
        // const index = expertState.profileData.expertTopics.map(item => item.name).indexOf(e.target.value);
        const payload = {
            domainId: domainId,
            questionId: expertState.selectedQuestion
        }
        changeDomainExpert(payload).then((res) => {
            if (res===undefined) return;
            if (res.data.success || res.data.data !== '') {
                advanceFilterModalToggle({ bool: false, value: "" })
                // expertState.openPageData.filter((obj)=>{
                //     if(obj.questionUuid === payload.questionId)
                //     {
                //         obj.domain = domainName;
                //         return obj;
                //     }
                // })
                if(!currentRoute.pathname.includes('/open')){
                    navigate('/expertHome/open');
                }
                toast.success(changeDomainToast(res.data.message), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                callExpertOpenApi();
            }
        })
    }

    useEffect(() => {

    }, [expertState.userData])

    return (
        <Modal show={modalState.modalState}
            onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
            centered={true}
            size={"lg"}
            // style={{marginTop:"38px"}}
            scrollable={true}
        >
            <ModalHeader closeButton>
                <ModalTitle style={ModalHeaderStyles.styles}>
                    <h5 style={{marginBottom:0}}><i className="fa fa-repeat" style={{ paddingRight: "7px", fontSize: "16px" }}></i>Route Question to different Expert(s) </h5>
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div className="row" style={{paddingLeft:'3.5rem',paddingRight:'3.0rem',paddingBottom:'20px'}}>
                    <div className="container">
                        <FormControl className="col-md-12">
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                                defaultValue={isSelected}
                                onChange={onChangeOption}
                            >
                                <div style={{display:'flex',alignItems:'baseline',paddingBottom:'7px'}}>
                                <div>
                                <FormControlLabel value="a"   control={<Radio />} label={<Typography sx={{ fontFamily: "inherit", color: displaySection ? "#2a364a" : "#AAA", fontWeight: "500", fontSize: "14px" }}>Route question to Expert(s) based on Domain</Typography>} />
                                </div>
                                <div>
                                <MultiSelect disabled={!displaySection ? true : false} value={routeQuestionBasedOnDomain} isMulti={false} onChangeFunc={(e)=>onChangeDomainSelect(e)} />
                                </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col-md-2">
                                        <label className="labelDomain" style={{ color: displaySection ? null : "#aaa" }}>Domain</label>
                                    </div>
                                    {/* <div className="col-md-10">
                                        <div style={{ width: "80%" }}>
                                            <select defaultValue={expertState.getSelectedDomain} className="rerouteSelect" onChange={(e) => onChangeDomainSelect(e)} style={{ outline: "none", width: '100%', fontSize: '14px' }} disabled={!displaySection ? true : false} >{userState.expertTopics.map((arr, ind) => {
                                                return (
                                                    <option key={ind} value={arr.userUuid}>{arr.name}</option>
                                                )
                                            })}</select>
                                        </div>
                                        <span style={{ color: '#bb5e5e', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>{displaySection && domainName !== expertState.getSelectedDomain && domainMessage}</span>
                                    </div> */}
                                {/* </div> */}
                                <Grid container spacing={2}>
                                    {/* <Grid item md={2}>
                                        <label className="labelDomain" style={{ color: displaySection ? null : "#aaa" }}>Domain</label>
                                    </Grid> */}
                                    {/* <Grid item md={10}>
                                        <Box sx={{ maxWidth: "80%" }}>
                                            <FormControl fullWidth> */}
                                                {/* <InputLabel id="demo-simple-select-label">Domains</InputLabel> */}
                                                {/* <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Domains"
                                                    sx={{ height: "35px",outline:"none",fontSize:"13px" }}
                                                    onChange={onChangeDomainSelect}
                                                    disabled={!displaySection ? true : false}
                                                    defaultValue={domainName} 
                                                >
                                                    {
                                                        userState.expertTopics.map((arr,ind)=>{
                                                            return(
                                                                <MenuItem sx={{fontSize:"14px"}} key={ind} value={arr.name}>{arr.name}</MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select> */}
                                            {/* </FormControl>
                                        </Box>
                                    </Grid> */}
                                </Grid>
                                {displaySection ? <div className="row">
                                    <div className="col-md-12">
                                        <div style={{ justifyContent: "center", display: "flex", paddingTop: "12px",gap:'12px' }}>
                                            {/* <button className="rerouteBtn" onClick={() => changeDomain()} disabled={domainName === expertState.getSelectedDomain ? true : false}>Change Domain</button> */}
                                            {/* <button className="cancelBtn" onClick={() => advanceFilterModalToggle({ bool: false, value: "" })} >Cancel</button> */}
                                            <Button2 children={'Cancel'} type={'dark'} onClickFunc={()=>advanceFilterModalToggle({bool:false,value:""})} />
                                            {routeQuestionBasedOnDomain.value === expertState.getSelectedDomain ? <span style={{opacity:'0.5',pointerEvents:'none'}}><Button text={'Change Domain'} type={'primary'} onClickFunc={changeDomain}/></span> :<Button text={'Change Domain'} onClickFunc={changeDomain} type={'primary'}/>}
                                        </div>
                                    </div>
                                </div> : null}
                                <div className="col-md-12">
                                    <span className="textCentered">
                                        or
                                    </span>
                                </div>
                                <FormControlLabel value="b" control={<Radio />} label={<Typography sx={{ fontFamily: "inherit", color: displaySection ? "#aaa" : "#2a364a", fontWeight: 500, fontSize: "14px" }}>Choose from a  list of Experts to assign this question</Typography>} />
                                {/* <div className="row mb-3">
                                    <div className="col-md-2">
                                        <label className="labelDomain" style={{ color: displaySection ? "#aaa" : null }}>Domains</label>
                                    </div>
                                    <div className="col-md-10">
                                        <div style={{ width: "80%" }}>
                                            {userState.expertTopics.length > 0 &&
                                                <select onChange={(e) => onChangeFetchUsers(e)} style={{ width: "100%" }} defaultValue={expertState.getSelectedDomain} className="rerouteSelect" disabled={displaySection ? true : false}>
                                                    {
                                                        userState.expertTopics.map((arr, i) => {
                                                            return (<option key={i} value={arr.name} >{arr.name}</option>)
                                                        })
                                                    }
                                                </select>
                                            }
                                        </div>
                                    </div>
                                </div> */}
                                <Grid container spacing={2} paddingBottom={2} display="flex" alignItems={'self-start'}>
                                    <Grid item md={6} justifyItems="end" sx={{paddingTop:0,marginTop:'-3px'}}>
                                    <span className="labelDomain" style={{ color: displaySection ? "#aaa" : "#2a364a",fontWeight: displaySection ? "normal" : 400, fontSize:'14px',display:'flex',justifyContent:'end',alignSelf:'self-start' }}>Filter Experts by Domain&nbsp;</span>
                                    </Grid>
                                    <Grid item md={6}>
                                            <FormControl fullWidth>
                                                {/* <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Domains"
                                                    sx={{ height: "35px", outline: "none", fontSize: "13px" }}
                                                    onChange={onChangeFetchUsers}
                                                    disabled={displaySection ? true : false}
                                                    defaultValue={domainName}
                                                >
                                                    {
                                                        userState.expertTopics.length > 0 &&
                                                        userState.expertTopics.map((arr, ind) => {
                                                            return (
                                                                <MenuItem sx={{fontSize:"14px"}} key={ind} value={arr.name}>{arr.name}</MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select> */}
                                                <MultiSelect disabled={displaySection ? true : false} value={domainName} onChangeFunc={onChangeFetchUsers} />
                                            </FormControl>
                                        </Grid>
                                </Grid>
                                <Grid container spacing={2} paddingBottom={1} display="flex" alignItems={'baseline'}>
                                    <Grid item md={6} justifyItems="end" sx={{paddingTop:0}}>
                                    <span className="labelDomain" style={{ color: displaySection ? "#aaa" : '#2a364a',display:'flex',justifyContent:'end' }}>Experts&nbsp;</span>
                                    </Grid>
                                    <Grid item md={6}>                                       
                                     <MultiSelect placeholder={'Select Experts'} disabled={displaySection? true : false} listOptions={expertState.userData.users} value={optvalue} onChangeFunc={onChangeSelectedUser} />
                                            {/* <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Experts</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Experts"
                                                    sx={{ outline: "none", fontSize: "13px", }}
                                                    onChange={onChangeSelectedUser}
                                                    disabled={displaySection ? true : false}
                                                    value={optvalue}
                                                    placeholder="hello"
                                                    defaultValue="Choose an Expert"
                                                >
                                                     {selectedUser.length > 0 &&<MenuItem value=""></MenuItem>}
                                                     {expertState.userData.users.length === 0 && <option>No Expert available</option>}
                                                    {expertState.userData.users.length > 0 && <ListSubheader>Assigned Users
                                                        {
                                                            expertState.userData.users.length > 0 &&
                                                            expertState.userData.users.map((usr, i) => {
                                                                if (usr.questionAssigned === true) {
                                                                    return (<MenuItem sx={{fontSize:"14px"}}  className="rerouteSelect" key={i} disabled={usr.questionAssigned ? true : false}>{usr.firstName}&nbsp;{usr.lastName}</MenuItem>)
                                                                }
                                                                else {
                                                                    return null;
                                                                }
                                                            })
                                                        }
                                                    </ListSubheader>
                                                    }
                                                    {expertState.userData.users.length !== 0 && <ListSubheader>Choose an Expert</ListSubheader>}
                                                    {
                                                        userList.length > 0 &&
                                                        userList.map((usr, i) => {
                                                            return (
                                                                <MenuItem sx={{ fontSize: "14px" }} value={usr.userUuid} key={i}>{usr.firstName}&nbsp;{usr.lastName}</MenuItem>
                                                            )
                                                        })
                                                    }     
                                                </Select>
                                            </FormControl> */}
                                    </Grid>
                                </Grid>
                                {
                                            selectedUser.length > 0 && displaySection === false && <div style={{marginBottom:"7px",textAlign:'center',display:'flex',flexDirection:'column',alignItems:'center'}}>
                                                {
                                                    selectedUser.length > 0 && selectedUser.map((arr, ind) => {
                                                        return (
                                                            <>
                                                                <div onClick={() => addUsersList(arr)} style={{ marginTop: "3px", marginBottom: "3px" }} key={ind} className="selectedUserSQM">
                                                                    {arr.firstName}&nbsp;{arr.lastName}&nbsp;({arr.email})
                                                                    <span className="crossButton">x</span>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                {/* <Grid container spacing={2}>
                                    <Grid item md={12}>
                                        <p style={{ color: displaySection ? "#aaa" : "#333", marginTop: "12px", marginBottom: "3px", fontSize: "14px" }}>Reason for rerouting the question:</p>
                                        <textarea onChange={(e) => commentInput(e)} disabled={displaySection ? true : false} className="textareaDiv" rows={3} placeholder="Please provide a reason for force routing this question to specified experts..."></textarea>
                                    </Grid>
                                </Grid> */}
                                {
                                    displaySection ? null :
                                        <>
                                            <Grid container spacing={2}>
                                                <Grid item md={12} sx={{justifyContent:"center",display:"flex",gap:'12px'}} >
                                                    {/* <button className="rerouteBtn" onClick={() => onClickReroute()} disabled={selectedUser.length === 0 ? true : false}>Reroute</button> */}
                                                    {/* <button className="cancelBtn" onClick={() => onClickCancel()}>Cancel</button> */}
                                                    <Button2  children={'Cancel'} type='dark' onClickFunc={onClickCancel} />
                                                    {selectedUser.length === 0 ?
                                                    <span style={{opacity:'0.5',pointerEvents:'none'}}>
                                                        <Button text={'Reroute'} type={'primary'} onClickFunc={onClickReroute} />
                                                    </span> :<Button text='Reroute' onClickFunc={onClickReroute} type={'primary'} />}
                                                </Grid>
                                            </Grid>
                                        </>
                                }
                            </RadioGroup>
                        </FormControl>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}
